<template>
  <form
    id="ometria-form-private-sale"
    ref="container"
    class="private-sale main-product__form-footer-action"
    action="https://api.ometria.com/forms/signup"
    method="post"
    @submit.prevent="(event) => handleSubmit(event)"
  >
    <input
      type="hidden"
      name="__form_id"
      :value="privateSaleFormId"
    >
    <input
      type="hidden"
      :name="email"
      value=""
      autocomplete="off"
    >
    <input
      class="is-hidden"
      name="__email"
      type="email"
      value=""
      autocomplete="off"
    >

    <input
      name="@account"
      type="hidden"
      :value="accountId"
    >
    <input
      name="@add_to_lists[]"
      type="hidden"
      :value="privateSaleListId"
    >
    <input
      name="@return_url"
      type="hidden"
      value=""
    >
    <input
      name="@subscription_status"
      type="hidden"
      value="SUBSCRIBED"
    >

    <div className="form-group__field">
      <label
        className="form-group__label text-desktop-14"
        htmlFor="form-group-text"
        v-text="inputLabel"
      />

      <input
        id="form-group-text"
        ref="privateSaleInput"
        v-model="email"
        name="ue"
        class="private-sale__input text-desktop-14"
        :class="{
          ['private-sale__input--success']: formState === 'success'
        }"
        type="email"
        required
      >
    </div>

    <btn
      type="submit"
      class="
          text-desktop-10
          private-sale__button
        "
      :class="{
        ['private-sale__button--disabled']: formState === 'submitting',
        ['private-sale__button--error']: formState === 'error',
        [$class('hidden')]: formState === 'success',
      }"
      block-class="product-form"
      :label="buttonLabel"
      :show-text-icon="false"
    />

    <div
      v-if="formState != 'success'"
      class="checkbox private-sale__checkbox"
    >
      <input
        id="private-sale-confirm"
        class="checkbox__input"
        type="checkbox"
        required
      >
      <label
        class="checkbox__label"
        htmlFor="private-sale-confirm"
        v-html="$string('product.private_sale.confirm')"
      />
    </div>
  </form>
</template>

<script>

/**
 * Vue: Private sale (private-sale)
 * -----------------------------------------------------------------------------
 * Snippet to handle adding a user to ometria Private sale list.
 *
 * @param {Boolean, Object} product - Shopify product object.
 * @param {Boolean, Object} variant - Shopify product variant object.
 */
import FormFields from '~/components/form-fields'
import Btn from '~global/btn/btn'

import { mapState } from 'vuex'

export default {
  name: 'PrivateSale',

  components: {
    Btn,
  },

  props: {
    privateSaleListId: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      email: '',
      formState: 'pending',
      accountId: '',
      privateSaleFormId: '',
      ometriaInitialized: false,
    }
  },

  computed: {

    /**
     * Map Vuex state.
     */
    ...mapState({
      isMobile: (state) => state.index.screen.mobile,
    }),

    /**
     * Computes a label based on screen size.
     * @returns {String}
     */
    inputLabel() {
      return this.isMobile
        ? this.$string('product.back_in_stock.type_email')
        : this.$string('product.back_in_stock.email')
    },

    /**
     * Computes a label based on form state.
     * @returns {String}
     */
    buttonLabel() {
      return this.formState === 'submitting'
        ? this.$string('product.back_in_stock.sending')
        : this.$string('product.back_in_stock.cta')
    },
  },

  mounted() {
    this.getOmetriaDetails()
    FormFields().init()
  },

  methods: {

    /**
     * Gets global ometria details
     */
    getOmetriaDetails() {
      if (!cnvs.ometria) {
        return
      }

      this.accountId = cnvs.ometria?.accountId
      this.privateSaleFormId = cnvs.ometria?.privateSaleFormId
    },

    /**
     * Handles updating the messages displayed on adding to Private sale.
     * @param {String} message - Message to be displayed.
     * @param {String} state - Whether the message is a success or an error.
     */
    updateFormMessage(message, state) {
      this.email = message

      if (state !== 'success') {
        this.formState = 'error'
      }

      this.formState = 'success'
    },

    /**
     * Clears the form by resetting the initial data.
     */
    clearForm() {
      this.email = ''
      this.formState = 'pending'
      const input = this.$refs.privateSaleInput
      input.value = ''

      FormFields().handleInputUpdate(
        {
          type: 'blur',
        },
        input,
      )
    },

    /**
     * Submits the form to Ometria Private sale list.
     */
    handleSubmit(event) {
      this.formState = 'submitting'
      if (!this.$refs.container) {
        return
      }

      const formElements = event.target.elements

      const urlEncodedDataPairs = Object.keys(formElements)

        .map((key) => {
          return `${encodeURIComponent(formElements[key].name)}=${encodeURIComponent(formElements[key].value)}`
        })

      let formBody = []

      formBody = urlEncodedDataPairs.join('&').replace(/%20/g, '+')

      fetch('https://api.ometria.com/forms/signup/ajax', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
        },
        body: formBody,
      }).then((response) => {
        if (response.ok) {
          this.updateFormMessage(this.$string('product.back_in_stock.success'), 'success')
        } else {
          this.updateFormMessage(this.$string('product.back_in_stock.generic_error'), 'error')
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import './private-sale';
</style>
